import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';
import { Snowflake, BatteryCharging, Armchair } from "lucide-react";
import fleetBus from '../images/fleet2.jpeg';
import tourism from '../images/tourism.jpeg';
import truck from '../images/truck.jpeg';
import disabled from '../images/disabled2.jpeg';

export default function Fleet() {
    const { t } = useTranslation();

    const fleet = [
        {
            name: t('largeBus'),
            capacity: "50 " + t('pass'),
            features: [t('airCondition'), t('firstAid'), t('audioSystem'), t('readingLight')],
            image: fleetBus,//"https://images.unsplash.com/photo-1570125909232-eb263c188f7e?q=80&w=2071&auto=format&fit=crop",
        },
        {
            name: t('specialCaseBus'),
            capacity: "15 " + t('pass'),
            features: [t('airCondition'), t('firstAid'), t('specialCaseLoading')],
            image: disabled,//"https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?q=80&w=2069&auto=format&fit=crop",
        },
        {
            name: t('tourismBus'),
            capacity: "18 " + t('pass'),
            features: [t('airCondition'), t('firstAid')],
            image: tourism,//"https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?q=80&w=2069&auto=format&fit=crop",
        },
        {
            name: t('bagsTrucks'),
            features: [t('loadBagsContainers')],
            image: truck,//"https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?q=80&w=2069&auto=format&fit=crop",
        }
    ];

    const amenities = [
        { icon: <Snowflake size={18} />, label: t('airConditioning') },
        { icon: <Armchair size={18} />, label: t('comfortableSeats') },
        { icon: <BatteryCharging size={18} />, label: t('usbChargers') },
    ];


    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });  
    }, []);

    return (
        <div className="min-h-screen pt-10 pb-20 bg-background" dir={t('dir')}>
            <div className="container px-4 mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-16"
                >
                    <h1 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900 dark:text-white">
                        {t('fleet')}
                    </h1>
                    <div className="h-1.5 w-24 bg-accent mx-auto rounded-full" />
                    <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                        {t('modernFleetDesc')}
                    </p>
                </motion.div>

                {/* Amenities */}
                <section style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "15px" }}>
                        {amenities.map((item, index) => (
                            <div key={index} style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "8px 15px",
                                borderRadius: "20px",
                                border: "1px solid #ddd",
                                background: "#f3f3f3"
                            }}>
                                <div style={{ color: "hsl(30, 93%, 47%)" }}>{item.icon}</div>
                                <span className="font-medium text-sm">{item.label}</span>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Fleet Cards */}
                <section style={{ padding: "60px 20px" }}>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
                        gap: "20px"
                    }}>
                        {fleet.map((bus, index) => (
                            <div key={index} style={{
                                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                borderRadius: "10px",
                                overflow: "hidden",
                                background: "white"
                            }}>
                                <img
                                    src={bus.image}
                                    alt={bus.name}
                                    style={{ width: "100%", height: "230px", objectFit: "cover" }}
                                />

                                <div style={{ padding: "20px" }}>
                                    <h3>{bus.name}</h3>
                                    {bus.capacity && <p><strong>{t('capacity')}:</strong> {bus.capacity}</p>}

                                    <p style={{ marginTop: "15px" }}><strong>{t('features')}:</strong></p>
                                    <ul>
                                        {bus.features.map((feature, i) => (
                                            <li key={i}>{feature}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
}
